import { supabaseClient } from "../../config/supabase.config"
import { SUPABASE_ENDPOINTS } from "../../constants/supabase-tables"
import { CacheConfig } from "../../lib/parser"

export const uploadSwagger = async (
	getToken: (
		options?: { template: string } | undefined
	) => Promise<string | null>,
	values: CacheConfig & {
		user_id: string
		org_id: string
		source: string
		workspace_id: string
		source_url: string
	}
) => {
	const supabaseAccessToken = (await getToken({
		template: "supabase",
	})) as string
	const supabase = supabaseClient(supabaseAccessToken)
	delete values?.orgId
	return await supabase
		.from(SUPABASE_ENDPOINTS)
		.insert({ ...values })
		.select()
		.single()
}
